import React,{memo} from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  Row,
  Col,
  HeadingText,
  BodyText,
  Link,
} from '@paypalcorp/pp-react'
import { object } from 'prop-types'

const TextContent =
  ({icon,content}) => (
  <>
    <SvgIcon {...icon}/>
    <HeadingText
        size={content?.heading.size}
        className={content?.heading?.className}
        id={content?.heading.id}
      >
        <Message id={content?.heading.messageId} />
      </HeadingText>
    <Description {...content}/>
</>
)


const Description = ({ description, link }) => (
  <BodyText className={`${description?.className}` } id={description?.id}>
    <Message
      id={description.messageId}
      link={(innerMessage) => (
        <Link
          name={link?.name}
          href={link?.href}
          className={link?.className}
          id={link?.id}
          size={link.size}
        >
          {innerMessage}
        </Link>
      )}
    />
  </BodyText>
)
const SvgIcon =memo(({url,className,alt}) => (
    <div className={className}>
       <img
          src={url}
          alt={alt}
          className={`icon`}
          loading="lazy"
        />
      <div className='icon-white-bg-wrapper'>
          <span className='banner-icon'/>
        </div>
  </div>
))
SvgIcon.displayName ='SvgIcon';

const PrivacyHubHeader =({icon,banner,content,children})=>{
    return(
    <>
        <Row className="row privacy-hub-header" noGutters>
        <Col xs={{ order: 2,span: 12 }} md={{ order:1,span: 6 }} className='header-column'>
          <TextContent icon={icon} content ={content}/>
          {children}
        </Col>
        <Col xs={{ order: 1,span: 12 }} md={{ order:2,span: 6 }} className='header-column'>
          <SvgIcon {...banner}/>
        </Col>
        </Row>
    </>)
}

PrivacyHubHeader.displayName ='PrivacyHubHeader'

PrivacyHubHeader.propTypes = {
    icon: object,
    banner: object,
    content:object,
  }
export default PrivacyHubHeader
